// extracted by css-extract-rspack-plugin
export default {"rowSelection":"zXFq4ojdELYTn5XR","rowSelectionChecked":"OFfBKUk4S7kKhG4S"};